import { FormattedMessage } from 'react-intl';

import MonitoringIssuesList from 'src/features/monitoring/components/MonitoringIssuesList';
import { MonitoringHealthIssue } from 'src/features/monitoring/types';
import { ComponentStatusBadgeOptions } from 'src/features/systems/utils/constants';
import { SYSTEM_COMPONENT_STATUS } from 'src/features/systems/utils/types';
import { Badge } from 'src/registry/ui/Badge';
import { HoverCard, HoverCardContent, HoverCardTrigger } from 'src/registry/ui/HoverCard';

export const HAS_ISSUES_STATUSES: SYSTEM_COMPONENT_STATUS[] = [
    SYSTEM_COMPONENT_STATUS.ERROR,
    SYSTEM_COMPONENT_STATUS.WARNING,
    SYSTEM_COMPONENT_STATUS.NO_CONNECTION,
];

type Props = {
    status: SYSTEM_COMPONENT_STATUS;
    activeIssueCount: number;
    isOpen: boolean;
    onOpenChange: (open: boolean) => void;
    isLoadingIssues: boolean;
    issues?: MonitoringHealthIssue[];
};

export default function HealthIssuesHoverBadge({
    status,
    activeIssueCount,
    isOpen,
    onOpenChange,
    isLoadingIssues,
    issues,
}: Props) {
    const statusOption = ComponentStatusBadgeOptions[status];
    const showCount = HAS_ISSUES_STATUSES.includes(status) && activeIssueCount > 0;

    const badge = (
        <Badge theme={statusOption.theme} className={`gap-1 ${showCount ? 'cursor-pointer' : ''}`}>
            <FormattedMessage {...statusOption.label} />
            {showCount && <span>· {activeIssueCount}</span>}
        </Badge>
    );

    if (!showCount) return badge;

    return (
        <HoverCard open={isOpen} onOpenChange={onOpenChange} openDelay={100} closeDelay={150}>
            <HoverCardTrigger asChild>{badge}</HoverCardTrigger>
            <HoverCardContent align="end" side="bottom" className="w-80 max-w-[90vw]">
                <MonitoringIssuesList
                    isLoading={isLoadingIssues}
                    issues={issues}
                    fallbackCount={activeIssueCount}
                />
            </HoverCardContent>
        </HoverCard>
    );
}
